import { generateUUID } from ".";

const COOKIE_DOMAIN = window.location.hostname; // allows subdomains
const COOKIE_PATH = "/";

export const getTokenCookie = () => {
  let allcookies = document.cookie.split(';');
  let token = false;
  for (let i = 0; i < allcookies.length; i++) {
    if (allcookies[i].split("=")[0].trim() === "access_token") {
      token = allcookies[i].split("=")[1];
    }
  }

  return token;
};

export const setToken = (access_token) => {
  let token = window.sessionStorage.setItem("access_token", access_token);
  window.localStorage.setItem("access_token", access_token);
  window.sessionStorage.removeItem("temp");
  return token;
};

export const removeToken = () => {
  window.sessionStorage.removeItem("access_token");
};

export const setFirebaseToken = (access_token) => {
  let token = window.sessionStorage.setItem("fcm_token", access_token);
  return token;
};

export const setTokenTemp = (access_token) => {
  let token = window.sessionStorage.setItem("access_token", access_token);
  window.sessionStorage.setItem("temp", "1");
  return token;
};

export const isWhitelabel = () => {
  return sessionStorage.getItem("isWhitelabel") === "true" ? true : false;
};

export const getToken = () => {
  let token = window.sessionStorage.getItem("access_token");
  token = token == "null" ? null : token;

  if(!isJwt(token)){
    return false;
  }
  return token;
};


export const getServiceProviderToken = () => {
  let token = window.sessionStorage.getItem("service_provider_token");
  return token;
};


export const getRedirect = () => {
  const match = document.cookie
    .split("; ")
    .find(row => row.startsWith("redirect="));

  return match ? match.split("=")[1] : null;
};

export const removeRedirect = () => {
  document.cookie =
    `redirect=; ` +
    `Path=${COOKIE_PATH}; ` +
    `Domain=${COOKIE_DOMAIN}; ` +
    `Expires=Thu, 01 Jan 1970 00:00:00 GMT; ` +
    `SameSite=None; Secure`;
};

export const setServiceProviderToken = (access_token) => {
  let token = window.sessionStorage.setItem("service_provider_token", access_token);
  return token;
};

export const setRedirect = (value) => {
  document.cookie =
    `redirect=${value}; ` +
    `Path=${COOKIE_PATH}; ` +
    `Domain=${COOKIE_DOMAIN}; ` +
    `SameSite=None; Secure`;
};

export const setEnroll = (enroll) => {
  let token = window.sessionStorage.setItem("enroll", enroll);
  return token;
};

export const getFCMToken = () => {
  let token = window.sessionStorage.getItem("fcm_token");
  return token;
};

export const isLogin = () => {
  let token = window.sessionStorage.getItem("access_token");
  let temp = window.sessionStorage.getItem("temp");

  if(!isJwt(token)){
    return false;
  }

  if (token && !temp) {
    if(regoJWT(token)){
      return true;
    }
    return false;
  }
  return false;
};

export const isJwt=(token)=> {
  if (typeof token !== "string") return false;

  const parts = token.split(".");
  if (parts.length !== 3) return false;

  const base64UrlPattern = /^[A-Za-z0-9_-]+$/;
  if (!parts.every(part => base64UrlPattern.test(part))) return false;

  try {
    const header = JSON.parse(atob(parts[0].replace(/-/g, "+").replace(/_/g, "/")));
    const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));

    return typeof header === "object" && typeof payload === "object";
  } catch {
    return false;
  }
}

export const regoJWT = (token) => {
  try {
    if (!token) return false;

    const decoded = parseJWT(token);

    // normalize enroll (handle string/boolean/number)
    const enroll = decoded?.enroll;
    const isEnrollTrue =
      enroll === true ||
      enroll === 1 ||
      (typeof enroll === "string" && enroll.toLowerCase() === "true");

    // block conditions
    if (isEnrollTrue) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const parseJWT = (token) => {
  const base64Url = token.split('.')[1]; // payload
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload);
}

export const authToken = () => {
  const token = getToken();
  if (!token) {
    return { 'Idempotency-Key': generateUUID() };
  }
  return {
    "Authorization": `Bearer ${getToken()}`,
    'Idempotency-Key': generateUUID()
  }
};

export const authTokenPwd = (token) => {
  if (!token) {
    return { 'Idempotency-Key': generateUUID() };
  }
  return {
    "Authorization": `PasswordReset ${token}`,
    'Idempotency-Key': generateUUID()
  }
};

export const loginToken = (email, password) => {
  return {
    "Authorization": 'Basic ' + btoa(email + ':' + password),
    'Idempotency-Key': generateUUID()
  }
};

export const loginTokenAuth = (email, password) => {
  sessionStorage.setItem("email", email);
  return btoa(email + ':' + password)
};


